import Navigation from "@/components/Navigation";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Helmet } from "react-helmet";
import ChineseZodiacIcon from "@/components/ChineseZodiacIcon";

const HoroscopoRata = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Horóscopo Chino Rata - Predicciones Diarias | Midstino</title>
        <meta name="description" content="Horóscopo chino del signo Rata. Predicciones diarias de amor, trabajo y salud para los nacidos en los años de la Rata." />
      </Helmet>
      
      <Navigation />
      
      <main className="container mx-auto px-4 pt-24 pb-12">
        <Card className="max-w-4xl mx-auto">
          <CardContent className="p-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <ChineseZodiacIcon animal="rata" size={96} />
              </div>
              <h1 className="text-3xl font-bold mb-2">Rata</h1>
              <p className="text-muted-foreground">Años: 1924, 1936, 1948, 1960, 1972, 1984, 1996, 2008, 2020</p>
            </div>

            <Tabs defaultValue="hoy" className="w-full">
              <TabsList className="grid w-full grid-cols-3">
                <TabsTrigger value="hoy">Hoy</TabsTrigger>
                <TabsTrigger value="manana">Mañana</TabsTrigger>
                <TabsTrigger value="semana">Esta Semana</TabsTrigger>
              </TabsList>

              <TabsContent value="hoy" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu intuición está particularmente aguda hoy, Rata. Las personas nacidas bajo tu signo sentirán una conexión profunda con sus parejas. Si estás soltero, alguien inteligente y encantador podría captar tu atención.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu astucia natural será tu mejor aliada hoy. Es un momento excelente para negociar, planificar estrategias y resolver problemas complejos. Tu capacidad de adaptación será reconocida por tus superiores.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Cuida tu sistema nervioso. Tu mente activa necesita descanso. Practica técnicas de relajación y asegúrate de dormir lo suficiente para mantener tu energía característica.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="manana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mañana será un día favorable para expresar tus sentimientos. Tu carisma natural atraerá miradas admiradas. Las parejas disfrutarán de conversaciones estimulantes y conexiones profundas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Nuevas oportunidades se presentarán. Tu habilidad para ver detalles que otros pasan por alto te dará ventaja en proyectos importantes. Confía en tu instinto empresarial.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Tu energía estará en alza. Es un buen momento para iniciar nuevos hábitos saludables o retomar actividades físicas que habías dejado de lado.
                  </p>
                </div>
              </TabsContent>

              <TabsContent value="semana" className="space-y-6">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💝 Amor</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Esta semana promete romance y aventura. Tu naturaleza sociable atraerá a personas interesantes a tu vida. Las relaciones existentes se fortalecerán a través de experiencias compartidas.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">💼 Trabajo</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Una semana productiva te espera. Tu ingenio y rapidez mental te permitirán completar tareas eficientemente. Podrías recibir reconocimiento por tu trabajo innovador.
                  </p>
                </div>
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">🏥 Salud</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    Mantén el equilibrio entre actividad y descanso. Tu naturaleza inquieta necesita momentos de calma para recargar energías. Considera actividades como yoga o meditación.
                  </p>
                </div>
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default HoroscopoRata;
